import { Injectable, inject } from '@angular/core';
import { TrunkBaseConfigurationService } from '@core/services/trunk-base-configuration/trunk-base-configuration.service';
import { WsSyncConfigRepository } from '../repositories/ws-sync-config.repository';
import { WsSyncState } from '../state/ws-sync.state';

@Injectable({ providedIn: 'root' })
export class LoadActiveSyncsUseCase {
  private readonly repository = inject(WsSyncConfigRepository);
  private readonly state = inject(WsSyncState);
  private readonly trunkBaseConfigurationService = inject(TrunkBaseConfigurationService);

  execute(force = false): void {
    if (!this.trunkBaseConfigurationService.CIAContenidoWS) return;
    if (!force && this.state.activeListLoaded()) return;

    this.repository.listActive().subscribe({
      next: items => this.state.hydrateActive(items),
      error: () => {
        // Silencioso: si falla la carga inicial, los switches simplemente quedan en su estado por defecto.
      },
    });
  }
}
